import * as F from 'reduker/fp-utils'
import entities from 'reduker/entities'
import request from 'reduker/request'

import { PAGE_LIMIT } from './constants'
import pick from 'utils/pick'

export const getSelectedIds = state => state.invitations.selectedIds
export const getInvitationsList = state => state.invitations.list
export const getPaginationInfo = state => state.invitations.pagination

export const getInvitationsIds = F.pipe(getInvitationsList, Object.keys)

export const getSelectedIdsOnPage = state => {
  const selectedIds = getSelectedIds(state)
  const invitationsKeys = getInvitationsIds(state)

  return pick(selectedIds, invitationsKeys)
}

export const getInvitationsInfo = F.pipe(
  state => state.invitations.list,
  entities.getAsList,
  invitations => invitations.slice(0, PAGE_LIMIT),
)

export const getInvitationsRequest = state => state.invitations.request

export const getIsInvitationsFetching = F.pipe(
  getInvitationsRequest,
  request.getIsRequesting,
)

export const getInvitationsError = F.pipe(
  getInvitationsRequest,
  request.getError,
)

export const getSearchOptions = state => state.invitations.searchOptions

export const getSearchFilters = state => state.invitations.searchFilters

export const getCurrentPage = state => state.invitations.pagination.page
